// Removing dependency cycle from helper
export const formatAmountInRupees = val => {
  if (typeof val === 'string' || val instanceof String) {
    return `₹${val}`;
  }
  const roundedVal = Math.round(val * 100) / 100;
  return `₹${roundedVal.toLocaleString('en-IN')}`;
};
export const getMonthAndYearFromDate = (date, withComma) => {
  if (!date || date === undefined) {
    return ' ';
  }
  const d = new Date(date.split(' ')[0]);
  const month = d.toLocaleString('default', {
    month: 'long',
  });
  const year = d.toLocaleString('default', {
    year: '2-digit',
  });
  if (withComma) {
    return `${month}, ${year}`;
  }
  return `${month} ${year}`;
};
export const isCurrentMonth = date => {
  if (!date || date === undefined) {
    return false;
  }
  const d = new Date(date.split(' ')[0]);
  const currentDate = new Date();
  return (
    d.getMonth() === currentDate.getMonth() &&
    d.getFullYear() === currentDate.getFullYear()
  );
};
